import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://sponsormania.fr";

/**
 * Keeps <link rel="canonical"> in sync with the current pathname (SPA-safe).
 * Strips query params and trailing slash (except for root).
 */
export default function CanonicalLink() {
    const { pathname } = useLocation();

    useEffect(() => {
        const clean = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
        const url = `${SITE_ORIGIN}${clean}`;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);
    }, [pathname]);

    return null;
}
